/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://i8ogalns61.execute-api.ap-northeast-1.amazonaws.com/main",
            "region": "ap-northeast-1"
        },
        {
            "name": "jd",
            "endpoint": "https://5oyn2qfyf9.execute-api.ap-northeast-1.amazonaws.com/main",
            "region": "ap-northeast-1"
        },
        {
            "name": "sales",
            "endpoint": "https://ae6zzlyqid.execute-api.ap-northeast-1.amazonaws.com/main",
            "region": "ap-northeast-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://gekr2qg64vadzlfuyo4iahli5e.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "ap-northeast-1:2ce51b2c-a0b0-44da-b90a-4331ac4a6ef2",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_eEU9LssA8",
    "aws_user_pools_web_client_id": "1bgfabfif8qba3feq7cu7f6rcb",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "htattendance-20211031194603-hostingbucket-main",
    "aws_content_delivery_bucket_region": "ap-northeast-1",
    "aws_content_delivery_url": "http://htattendance-20211031194603-hostingbucket-main.s3-website-ap-northeast-1.amazonaws.com"
};


export default awsmobile;
